// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type LightBulb24FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const LightBulb24Filled: FC<LightBulb24FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="M12 22c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 0 1 10 20h4c0 .55-.196 1.02-.588 1.413A1.926 1.926 0 0 1 12 22Zm-4-3v-2h8v2H8Zm.25-3a7.662 7.662 0 0 1-2.737-2.75A7.278 7.278 0 0 1 4.5 9.5c0-2.083.73-3.854 2.188-5.313C8.146 2.73 9.916 2 12 2s3.854.73 5.313 2.188C18.77 5.646 19.5 7.417 19.5 9.5c0 1.35-.337 2.6-1.012 3.75A7.662 7.662 0 0 1 15.75 16h-7.5Z" />
        </svg>
    );
};

export default LightBulb24Filled;
